const flutterwaveConfig = {
  public_key: 'FLWPUBK-e6464876aec0ee68c549d9619d95377c-X',
  logoUrl:
    'https://res.cloudinary.com/djhh4kkml/image/upload/v1640135525/Ydev/android-icon-96x96_tlwntb.png',
}
export default flutterwaveConfig
